import React from "react";
import Section from "../components/Section";

export default function Experience() {
  return (
    <Section id="experience" title="Experience">
      <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
        <div className="flex-grow-1">
          <h3 className="mb-0">Recruitment Consultant - Contract</h3>
          <div className="subheading mb-3">HR Stream, Utah, U.S.A</div>
          <p>
            <strong>Roles/Responsibilities</strong><br />
            <li>Providing software consulting services to HR Stream’s clients.</li>
            <li>Utilizing a variety of direct and innovative IT sourcing approaches including social media, internet sourcing, name generation research, and networking to generate qualified IT candidates for various engineering roles.</li>
            <li>Implementing technical recruitment strategies that contribute to the enhancement of HR Stream global IT hiring processes.</li>
          </p>
        </div>
        <div className="flex-shrink-0">
        <span className="text-primary">April 2022 - Present</span>
        </div>
      </div>
      <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
        <div className="flex-grow-1">
          <h3 className="mb-0">Recruitment Consultant — Contract</h3>
          <div className="subheading mb-3">PG Consulting, Lagos, Nigeria</div>
          <p>
            <strong>Roles/Responsibilities</strong><br />
            <li>Building relationships with clients.</li>
            <li>Sourcing potential candidates on platforms such as LinkedIn, and GitHub.</li>
            <li>Serving as an ambassador for VGS Recruitment Solutions and representing her in potential candidates’ first interactions with the organization.</li>
            <li>Performing pre-screening calls to analyze applicants’ abilities.</li>
            <li>Coordinating with Technical team leaders to forecast department goals and hiring needs.</li>
            <li>Crafting and sending personalized recruiting emails with current job openings to passive candidates</li>
            <li>Keeping up-to-date with new technological trends and products.</li>
            <li>Creating a seamless candidate experience through all stages.</li>
            <li>Actively engaging and promoting diversity and inclusion in hiring strategies.</li>
          </p>
        </div>
        <div className="flex-shrink-0">
          <span className="text-primary">April 2022 - Present</span>
        </div>
      </div>
      <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
        <div className="flex-grow-1">
          <h3 className="mb-0">Senior Recruitment Consultant (Tech) - Contract</h3>
          <div className="subheading mb-3">Xapic Technologies, Lagos, Nigeria</div>
          <p>
            <strong>Roles/Responsibilities</strong><br />
            <li>Headhunted candidates</li>
            <li>Interviewed and assessed prospective applicants and matched them with vacancies at client companies</li>
            <li>Screened candidates and drew up shortlists of candidates for clients to interview</li>
            <li>Organised interviews and selection events</li>
            <li>Made arrangements for the advertisement of vacancies</li>
            <li>Helped applicants to prepare for interviews</li>
            <li>Built relationships with clients</li>
          </p>
        </div>
        <div className="flex-shrink-0">
          <span className="text-primary">March 2020 - March 2022</span>
        </div>
      </div>
      <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
        <div className="flex-grow-1">
          <h3 className="mb-0">Technical Recruiter || Frontend Developer</h3>
          <div className="subheading mb-3">Pericius Technologies Pvt. Ltd, Bangalore, India</div>
          <p>
            <strong>Roles/Responsibilities</strong><br />
            <li>Pinpointed candidate motivators and used them to successfully recruit quality candidates.</li>
            <li>Analyzed job descriptions and communicated with the Hiring Manager (Pericius Technologies Pvt. Ltd) to clarify terms that could be vague; earned job-satisfaction rates of 95 percent from candidate/company matches as a result of this attention to detail.</li>
            <li> Created new features, functionality and capabilities, specifically in the Contract Management System using ReactJS, Ant Design, Material UI and Java.</li>
            <li>Performed bug fixes and code reviews.</li>
            <li>Recommended solutions for a streamlined, user-friendly interface with the design team.</li>
          </p>
        </div>
        <div className="flex-shrink-0">
          <span className="text-primary">September 2021 - March 2022</span>
        </div>
      </div>
      <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
        <div className="flex-grow-1">
          <h3 className="mb-0">Technical Copywriter — Contract</h3>
          <div className="subheading mb-3">Marketpath Inc, Indianapolis, U.S.A</div>
          <p>
            <li> Gathered and analyzed technical and product information from various sources to document new or changing product functionality.</li>
            <li>Developed product manuals, how-to guides, website help sections, journal articles, and other content that distills technical information with ease and clarity.</li>
          </p>
        </div>
        <div className="flex-shrink-0">
          <span className="text-primary">August 2021 - November 2021</span>
        </div>
      </div>
      <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
        <div className="flex-grow-1">
          <h3 className="mb-0">Frontend Developer — Contract</h3>
          <div className="subheading mb-3">Mezovest, Lagos, Nigeria</div>
          <p>
            <li> Built an online payment gateway that allows businesses make and receive payments across continents, currencies, preferred payment methods, and platforms.</li>
          </p>
        </div>
        <div className="flex-shrink-0">
          <span className="text-primary">May 2021 - June 2021</span>
        </div>
      </div>
      <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
        <div className="flex-grow-1">
          <h3 className="mb-0">Software Developer — Contract</h3>
          <div className="subheading mb-3">Royal Crystal Airways, Lagos, Nigeria</div>
          <p>
            <li> Built the Web Application for Royal Crystal Airways and Royal Trip using ReactJS, Redux, jQuery, Vanilla JavaScript, Material-UI, TailwindCSS, Bootstrap, HTML5, CSS3, SASS, Stylus and ES6.</li>
            <li>Oversaw the outsourced Mobile Application development for Royal Crystal Airways and Royal Trip.</li>
          </p>
        </div>
        <div className="flex-shrink-0">
          <span className="text-primary">October 2020 - January 2021</span>
        </div>
      </div>
      <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
        <div className="flex-grow-1">
          <h3 className="mb-0">Frontend Developer — Part-Time</h3>
          <div className="subheading mb-3">Midra Solutions, Lagos, Nigeria</div>
          <p>
            <li>Maintained, optimized, troubleshot, and improved websites.</li>
            <li>Created standardized websites and mobile responsive applications using mobile-first approach and strategy.</li>
            <li>Implemented applications and landing pages from concept through deployment.</li>
            <li>Collaborated with product team members to implement new feature developments.</li>
            <li>Built reusable code for future use.</li>
          </p>
        </div>
        <div className="flex-shrink-0">
          <span className="text-primary">January 2019 - March 2020</span>
        </div>  
      </div>
      <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
        <div className="flex-grow-1">
          <h3 className="mb-0">Software Developer (Intern) — Full-Time</h3>
          <div className="subheading mb-3">Lagosbuild, Lagos, Nigeria</div>
          <p>
            <li>Standardized website output with a new, responsive, mobile-first approach and strategy.</li>
            <li>Assessed UX and UI designs for technical feasibility.</li>
            <li>Integrated data from various back-end services and databases.</li>
          </p>
        </div>
        <div className="flex-shrink-0">
          <span className="text-primary">January 2017 - January 2019</span>
        </div>
      </div>
    </Section>
  );
}
